import { DatadogRum } from '@datadog/browser-rum';
import { Analytics } from '../analytics';
import type { AnalyticsEventMap } from '../analytics-event-map';
import type { AnalyticsService } from '../analytics.service';
import { IdentifyUserOptions } from '../identify-user-options';

/**
 * Service for logging events to Datadog RUM.
 */
export class DatadogService implements AnalyticsService {
  /**
   * The Datadog RUM API instance.
   */
  private readonly _api: DatadogRum;

  /**
   * Creates an instance of the DatadogService.
   * @param api The Datadog RUM API instance.
   */
  constructor(api: DatadogRum) {
    this._api = api;
  }

  /**
   * Identifies a user in Datadog RUM.
   * @param options The user identification options.
   */
  public identify(options: IdentifyUserOptions): void {
    this._api.setUser({ ...options });
  }

  /**
   * Logs an analytics event to Datadog RUM.
   * @param event The event name.
   * @param payload The event payload.
   */
  public logEvent<T extends Analytics>(event: T, payload: AnalyticsEventMap[T]): void {
    this._api.addAction(event, payload);
  }
}
